import { render, staticRenderFns } from "./SettingSound.vue?vue&type=template&id=9a357be0&"
import script from "./SettingSound.vue?vue&type=script&lang=js&"
export * from "./SettingSound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports